import gql from 'graphql-tag';

export const GET_CONTACT_MESSAGE_LIST_BY_MEMBER_NO = gql`
query(
  $golf_group_code: String!
  $golf_code: String!
  $member_no: String!
  $reserve_no: String!
)
{
  getContactsMessageListAdmin(
    golf_group_code: $golf_group_code
    golf_code: $golf_code
    member_no: $member_no
    reserve_no: $reserve_no
  ){
    Message{
      id
      send_id
      reserve_no
      message
      completed
      created_at
    }
  }
}
`;

export const GET_CONTACT_MESSAGE_LIST_BY_RESERVE_NO = gql`
    query(
        $golf_group_code: String!
        $golf_code: String!
        $reserve_no: String!
    ){
        getContactsMessageListByReserveNoAdmin(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            reserve_no: $reserve_no
        ){
            Message{
                id
                send_id
                reserve_no
                message
                completed
                created_at
            }
        }
    }
`;

export const POST_MESSAGE_ADMIN = gql`
    mutation(
        $golf_group_code: String!
        $golf_code: String!
        $member_no:Int!
        $reserve_no: String!
        $send_id: Int
        $message: String
        $completed: Int!
        ){
        postMessageAdmin(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            member_no: $member_no
            reserve_no: $reserve_no
            send_id: $send_id
            message: $message
            completed: $completed
        ){
            result
        }
    }
`;

export const UPDATE_COMPLETE = gql`
    mutation(
    $reserve_no: String!
    $member_no: String!
    $golf_group_code: String!
    $golf_code: String!
    $completed: Int!
    ){
    updateComplete(
        reserve_no:  $reserve_no
        member_no: $member_no
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        completed: $completed
    ){
        result
    }
}
`;

export const SEND_INQUIRY_NOTICE_EMAIL = gql`
    mutation(
        $reserve_no: String
        $golf_group_code: String
        $golf_code: String
        $member_no: String
        $family_name: String
        $given_name: String
        ){
            VerifyNoticeInquiryEmail(
                reserve_no: $reserve_no
                golf_group_code: $golf_group_code
                golf_code: $golf_code
                member_no: $member_no
                family_name: $family_name
                given_name: $given_name
        ){
            result
        }
    }
`;

export const GET_ALL_CONTACT_MESSAGE_LIST = gql`
    query(
        $name: String
        $completed: Int
        $sort_option: Int
        $golf_group_code: String
        $golf_code: String
        $begin_row: Int
        $limit_rows: Int
    ){
        getAllMemberContactsMessageList(
            name: $name
            completed: $completed
            sort_option: $sort_option
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            begin_row: $begin_row
            limit_rows: $limit_rows
        ){
            MemberMessage{
                created_at
                member_no
                reserve_no
                golf_code
                golf_name
                send_id
                completed
                family_name
                given_name
                member_class
                code_name
                completed_name
            }
            count
        }
    }
`;
